import { Location } from '@nx-smartmonkey/shared/domain';

import { geocodingRepository } from '../repositories/geocoding';
import { GeocodingRepository } from '../repositories/geocoding/GeocodingRepository';
import eventsPanel from '../services/events';

export class GeocodingService {
  constructor(private geocodingRepository: GeocodingRepository) {}

  async postGeocode({ addresses, projectId }: { addresses: string[]; projectId?: string }): Promise<Location[]> {
    const geoLocations = await this.geocodingRepository.postGeocode({ addresses, projectId });

    geoLocations.forEach((location: Location) => {
      eventsPanel.geocode(location.original_input ?? `undefined`);
    });

    return geoLocations;
  }
}

export const geocodingService = new GeocodingService(geocodingRepository);
